module.exports = __webpack_public_path__ + "static/media/landing.455f533e.png";